import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import { HumanitiesBuildSection } from '../sections/humanities/HumanitiesBuildSection';
import { HumanitiesClassroomSection } from '../sections/humanities/HumanitiesClassroomSection';
import { HumanitiesCollaborationsSection } from '../sections/humanities/HumanitiesCollaborationsSection';
import { HumanitiesContactCTASection } from '../sections/humanities/HumanitiesContactCTASection';
import { HumanitiesHeroSection } from '../sections/humanities/HumanitiesHeroSection';
import { HumanitiesMissionSection } from '../sections/humanities/HumanitiesMissionSection';
import { HumanitiesNewsSection } from '../sections/humanities/HumanitiesNewsSection';

import styles from './HumanitiesPage.module.css';

export function HumanitiesPage() {
  useDocumentTitle('Humanities');

  return (
    <div className={styles.page}>
      <HumanitiesHeroSection />
      <HumanitiesMissionSection />
      <HumanitiesClassroomSection />
      <HumanitiesBuildSection />
      <HumanitiesCollaborationsSection />
      <HumanitiesNewsSection />
      <HumanitiesContactCTASection />
    </div>
  );
}
